import { motion } from "framer-motion";
import { images } from "../../utils/images";

const Ecosystem = () => {
  return (
    <div className="bg-dark py-20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-white mb-6">
              Our Ecosystem Roadmap
            </h2>
            <p className="text-gray-300 max-w-3xl mx-auto">
              Once we have a substantial user base on our platform, we will
              introduce a range of blockchain applications, gaming projects,
              tokens, exchanges, and Web 3.0 initiatives.
            </p>
            <p className="text-gray-300 max-w-3xl mx-auto mt-4">
              These projects will provide our users with ongoing, mutually
              rewarding profits and benefits from the community. Our disruptive
              business model is designed to create win-win situations, fostering
              exceptional growth for everyone involved.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="relative h-[500px] rounded-lg overflow-hidden shadow-xl"
          >
            <img
              src={images.ecosystem}
              alt="Ecosystem Dashboard"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Ecosystem;
